import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Checkout from '@/views/Checkout.vue';
import Login from '@/views/Login.vue';
import Forgotpw from '@/views/Forgotpw.vue';
import Changepw from '@/views/Changepw.vue';
import Register from '@/views/Register.vue';
import MyAccount from '@/views/MyAccount.vue';
import Order from '@/views/Order.vue';
import PaymentResponse from '@/views/PaymentResponse';

const routes = [
	{
		path: '/',
		component: Home,
		meta: {
			lang: 'ro'
		},
	},
	{
		path: '/en',
		component: Home,
		meta: {
			lang: 'en'
		},
	},
	{ 
		path: '/checkout', 
		component: Checkout 
	},
	{
		path: '/login',
		component: Login
	},
	{
		path: '/reset-password',
		component: Forgotpw
	},
	{
		path: '/change-password',
		component: Changepw
	},
	{
		path: '/register',
		component: Register
	},
	{
		name: 'Contul meu',
		path: '/my-account',
		component: MyAccount
	},
	{
		name: 'Detalii Bilete',
		path: '/ticket-details',
		component: Order
	},
	/*{
		name: 'Bilet in format PDF',
		path: '/eticket',
		component: () =>
			import('../views/Eticket.vue'),
	},*/
	{
		path: '/payment-response',
		component: PaymentResponse
	},
	{
		path: "/museums/:slug",
		name: "museum",
		component: () =>
			import('../views/Museum.vue'),
		props: true,
		meta: {
			lang: 'ro'
		}
	},
	{
		path: "/en/museums/:slug",
		name: "museum-en",
		component: () =>
			import('../views/Museum.vue'),
		props: true,
		meta: {
			lang: 'en'
		}
	},
	{
		path: '/terms',
		name: 'Terms',
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/Terms.vue'),
		meta: {
			title: 'Termeni si conditii',
		},
	},
	{
		path: '/faqs',
		name: 'Faqs',
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/Faqs.vue'),
		meta: {
			title: 'Intrebari frecvente',
		},
	},
	{
		path: '/factura',
		name: 'Invoice',
		component: () =>
			import('../views/InvoiceRequest.vue'),
		meta: {
			title: 'Cerere factura',
		},
	},
	{
		path: '/refund-policy',
		name: 'RefundPolicy',
		component: () =>
			import('../views/RefundPolicy.vue'),
		meta: {
			title: 'Politica de retur',
		},
	},
	{
		path: '/gdpr',
		name: 'Gdpr',
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/Gdpr.vue'),
		meta: {
			title: 'Termeni si conditii GDPR',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
		meta: {
			title: 'Contact',
		},
	},
	{
		path: '/:slug',
		name: 'MuseumList',
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/MuseumList.vue'),
		props: true,
		meta: {
			lang: 'ro'
		}
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/' 
	}

];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

/**
 * Below code will display the component/active page title
 * Powered by: Nangialai Stoman
 */

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.


	// Set HTML lang attribute based on route or app state
	document.documentElement.lang = to.meta.lang || 'ro'; // Default to 'en' if no lang specified


	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
